export default __webpack_public_path__ + "static/media/Amateur Sports.fbf3e310.jpg";